import { CommonRequest, Method, ServiceName, CommonResponse } from 'models/common/RestApi';
import { SetupExcpParam, ItemList } from 'models/setup/excp/excp';
import { callApi } from 'utils/ApiUtil';

export const getSetupPackingList = async (condition: SetupExcpParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/fobList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<ItemList[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as ItemList[];
};

export const getProjectPackingCnt = async (condition: SetupExcpParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/fobListCnt`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<SetupExcpParam> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupExcpParam;
};
